import type { AllRouteEndpoints } from "../routeTypes";

export const patchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionCacheKeys: AllRouteEndpoints[] = [
  "/engagement/campaign_data(/:campaign_id)",
];
